import Grid from "@mui/material/Grid2";
import { Typography } from "@mui/material";
import BrandsFilterCard from "../BrandsFilter/BrandsFilterCard";
import BrandsTable from "../BrandsTable/BrandsTable";
import { useSelector } from "react-redux";
import { selectUserToken } from "../../../../features/userSlice";
import { useEffect, useState } from "react";
import { dataCollectionBrandsEndPointLogic } from "../../../../logic/DataCollection/Brands/BrandsEndPointLogic";
import { useDispatch } from "react-redux";
import store from "../../../../store";
import SimpleBackdrop from "../../../BackDrop/BackDrop";

const BrandsBase = () => {
  const tableHeadings = {
    brand_name: "Brand Name",
    brand_id: "ID",
    username: "Account",
    company_name: "Company",
    site_name: "Websites",
    brand_isactive: "Status",
    raw_output_table_name: "Raw Table ID",
    interface_name: "Interface",
    quick_actions: "Quick Actions",
  };
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const BRAND_METADATA_QUERY_ID = "5171209863954432";
  const RAW_TABLE_METADATA_QUERY_ID = "5652708983832576";

  const { userData } = useSelector((state: any) => state.user);

  // Get all website_permissions
  const websitePermissions = userData?.data?.website_permissions || [];

  // Find entry with site_name === "bestbookiesandbettingsites"
  let website_shared_uid = null;

  for (const permission of websitePermissions) {
    const [id, details] = Object.entries(permission)[0];
    //@ts-ignore
    if (details.site_name === "bestbookiesandbettingsites") {
      website_shared_uid = id;
      break;
    }
  }

  // If not found, fallback to the first site's ID
  if (!website_shared_uid && websitePermissions.length > 0) {
    website_shared_uid = Object.keys(websitePermissions[0])[0];
  }

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        setIsLoading(true);
        await dataCollectionBrandsEndPointLogic.getAllBrands(
          oauthTokenHeader,
          BRAND_METADATA_QUERY_ID,
          RAW_TABLE_METADATA_QUERY_ID, // Pass the new query ID
          website_shared_uid,
          dispatch,
          setIsLoading
        );
      } catch (error) {
        store.dispatch({ type: "error", payload: { message: error } });
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBrands();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oauthTokenHeader, dispatch]);

  return (
    <>
      <Grid container alignItems="center" sx={{ mb: 2 }}>
        <Grid size={12} mb={2}>
          <Typography variant="h3" sx={{ fontSize: "24px" }}>
            Brand Data
          </Typography>
          <Typography variant="body2" sx={{ fontSize: "14px" }}>
            Get, edit and update brad data in Unifier, Fetcher and Business
            Advisor.
          </Typography>
        </Grid>
        <BrandsFilterCard />
      </Grid>
      {isLoading ? (
        <SimpleBackdrop />
      ) : (
        <BrandsTable tableHeadings={tableHeadings} />
      )}
    </>
  );
};

export default BrandsBase;
